import { combineReducers } from 'redux';
import ArtistsAll from './ArtistsReducers';
import ArtistSingle from './ArtistSingleReducers';
import AlbumsSlider from './AlbumsSliderReducer';
import ArtistTopSongs from './ArtistTopSongsReducers';
// if there are more than one reducer in this component, use combineReducers:

const artists = combineReducers({
    ArtistsAll,
    ArtistSingle,
    ArtistTopSongs,
    AlbumsSlider,
});

export default artists;
